import { render, staticRenderFns } from "./sticky-banner.vue?vue&type=template&id=7109e1b4"
import script from "./sticky-banner.vue?vue&type=script&lang=ts"
export * from "./sticky-banner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports